export default "/static/explore/b946185d86a00c241a56a2bd371c89821aef0275/_next/static/images/header-image-football-fan-380391f80ebf3ce0e8d99060414d3830.png";